/**
 * ** Preferred Hotels - Synxis **
 *
 * @exports partnership_10008
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    const isSynxis = !!window.location.hostname.match(/synxis.com/);
    const isPreferredBrand = window.location.hostname.includes('preferredhotels');
    /**
       * @memberOf module:partnership_10008
       */
    partnership.getId = function getId() {
        return '10008';
    };
    /**
       * @memberOf module:partnership_10008
       */
    partnership.check = function check() {
        return isSynxis || isPreferredBrand;
    };
    /**
       * @memberOf module:partnership_10008
       */
    partnership.getSiteId = function getSiteId() {
        const hotelId = thn.parseUrlParameter('hotel') || window._GlobalTokens?.HOTEL_ID || window.dtm_config?.dtmc_hotel_id || window.__NEXT_DATA__?.query?.synxisId;
        const externalId = isPreferredBrand ? `${hotelId}-B` : hotelId;
        let result = {};
        if (!hotelId) {
            result = { accountKey: '61B040D47B21470B4DF53E985ECD0E77' };
        }
        else {
            result = {
                externalId,
            };
        }
        return result;
    };
    /**
       * @memberOf module:partnership_10008
       */
    partnership.boot = function boot() {
        const dataLayer = window.dataLayer;
        if (!dataLayer && !isPreferredBrand) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 300);
        let dataLayerHelper = new thn.DataLayerHelper(dataLayer, function (model, message) {
            if (message.event?.match(/gtm.historyChange/) || !thn.empty(message.propertyAverageRate)) { // url change detection
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    return partnership;
}

export { factory };
